import { CUSTOM_ELEMENTS_SCHEMA, NgModule, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';


import { MatCardModule } from '@angular/material/card';
import { MatToolbarModule } from "@angular/material/toolbar";

import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from "@angular/material/divider";
import { FilterDialogComponent } from './components/filter-dialog/filter-dialog.component'
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';

import { MenuHomepageComponent } from './pages/menu-homepage/menu-homepage.component';
import { LandingpageComponent } from './pages/landingpage/landingpage.component';

import { MenuCategoriesComponent } from './components/menu-categories/menu-categories.component';
import { MenuCategoryComponent } from './components/menu-category/menu-category.component';
import { FoodCardComponent } from './components/menu-food-card/menu-food-card.component';
import { DrinkCardComponent } from './components/menu-drink-card/menu-drink-card.component';
import { MenuCategoryPremiereComponent } from './components/menu-category-premiere/menu-category-premiere.component';
import { MenuNavigationComponent } from './components/menu-navigation/menu-navigation.component';
import { RestaurantTitleComponent } from './components/menu-restaurant-title/menu-restaurant-title.component';

import { DataService } from './services/data.service';
import { IntToColorPipe } from './pipes/int-to-color.pipe';
import { SortFoodsPipe } from './pipes/sort-foods.pipe';
import { MenuHeaderImageComponent } from './components/menu-header-image/menu-header-image.component';
import { MenuBasketComponent } from './components/menu-basket/menu-basket.component';
import { MenuBasketOrderComponent } from './components/menu-basket-order/menu-basket-order.component';
import { MenuBasketDialogComponent } from './components/menu-basket-dialog/menu-basket-dialog.component';
import { MenuFoodDialogComponent } from './components/menu-food-dialog/menu-food-dialog.component';
import { MenuDrinkDialogComponent } from './components/menu-drink-dialog/menu-drink-dialog.component';

// food
import { MenuFoodRecomendationDialogComponent } from './components/menu-food-recomendation-dialog/menu-food-recomendation-dialog.component';
import { MenuDrinkRecomendationDialogComponent } from './components/menu-drink-recomendation-dialog/menu-drink-recomendation-dialog.component';

import { MenuModificatorsGridComponent } from './components/menu-modificators-grid/menu-modificators-grid.component';
import { MenuDialogFoodVariantsComponent } from './components/menu-dialog-food-variants/menu-dialog-food-variants.component';
import { MenuRecomendationFoodVariantsComponent } from './components/menu-recomendation-food-variants/menu-recomendation-food-variants.component';
import { MenuRecomendationDrinkVariantsComponent } from './components/menu-recomendation-drink-variants/menu-recomendation-drink-variants.component';
import { MenuDialogDrinkVariantsComponent } from './components/menu-dialog-drink-variants/menu-dialog-drink-variants.component';
import { MenuBasketFoodCardComponent } from './components/menu-basket-food-card/menu-basket-food-card.component';
import { MenuBasketDrinkCardComponent } from './components/menu-basket-drink-card/menu-basket-drink-card.component';
import { MenuRecomendationsComponent } from './components/menu-recomendations/menu-recomendations.component';

// Pipes
import { LabelTranslatePipe } from './pipes/label-translate.pipe';
import { TranslatePipe } from './pipes/translate.pipe';
import { FieldTranslatePipe } from './pipes/field-translate.pipe';

// Firebase (без @angular/fire)
import { firebaseProviders } from './firebase.providers';
import { environment } from '../environments/environment';
import { MenuShowCardsComponent } from './components/menu-event-slider/menu-event-slider.component';
import { NgOptimizedImage } from '@angular/common';
import { MenuFooterComponent } from './components/menu-footer/menu-footer.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { TitleTranslatePipe } from './pipes/title-translate.pipe';
import { PriceSeparatorPipe } from './pipes/price-separator.pipe';
import { CachedImagePipe } from './pipes/cached-image.pipe';
import { MenuModificatorCardComponent } from './components/menu-modificator-card/menu-modificator-card.component';
import { MenuRecomendationCardFoodComponent } from './components/menu-recomendation-card-food/menu-recomendation-card-food.component';
import { MenuRecomendationCardDrinkComponent } from './components/menu-recomendation-card-drink/menu-recomendation-card-drink.component';
import { LazyImageComponent } from './components/lazy-image/lazy-image.component';
import { MenuEventCardComponent } from './components/menu-event-card/menu-event-card.component';

import { MenuOrderComponent } from './components/menu-order/menu-order.component';
import { MenuOrderDialogComponent } from './components/menu-order-dialog/menu-order-dialog.component';
import { MenuOrderFoodCardComponent } from './components/menu-order-food-card/menu-order-food-card.component';
import { MenuOrderDrinkCardComponent } from './components/menu-order-drink-card/menu-order-drink-card.component';
import { HttpClientModule } from '@angular/common/http';
import { MenuFooterDialogComponent } from './components/menu-footer-dialog/menu-footer-dialog.component';
import { MenuSuccessPageComponent } from './pages/menu-successpage/menu-successpage.component';
import { FilterFoodsPipe } from './pipes/filter-foods.pipe';
import { FilterDrinksPipe } from './pipes/filter-drinks.pipe';
import { TimeFormatPipe } from './pipes/time-format.pipe';
import { MenuNotificationComponent } from './components/menu-notification/menu-notification.component';
import { MenuCallingWaiterComponent } from './components/menu-calling-waiter/menu-calling-waiter.component';
import { MenuWaiterCallComponent } from './components/menu-waiter-call/menu-waiter-call.component';

import { MenuAllergenIconComponent } from './components/menu-allergen-icon/menu-allergen-icon.component';
import { MenuAllergenPillComponent } from './components/menu-allergen-pill/menu-allergen-pill.component';
import { MenuAllergenListComponent } from './components/menu-allergen-list/menu-allergen-list.component';
import { MenuAllergyNoticeComponent } from './components/menu-allergy-notice/menu-allergy-notice.component';
import { AllergenTranslatePipe } from './pipes/allergen-translate.pipe';
import { MenuSearchComponent } from './components/menu-search/menu-search.component';
import { MenuLabelBannersComponent } from './components/menu-label-banners/menu-label-banners.component';
import { AllergensWithAddonsPipe } from './pipes/allergens-with-addons.pipe';

// Десктоп-меню (ссылка заведения на широком экране)
import { DesktopMenuComponent } from './desktop/desktop-menu/desktop-menu.component';
import { DesktopItemCardComponent } from './desktop/desktop-item-card/desktop-item-card.component';
import { DesktopItemDialogComponent } from './desktop/desktop-item-dialog/desktop-item-dialog.component';
import { DesktopEventsComponent } from './desktop/desktop-events/desktop-events.component';
import { DesktopFooterComponent } from './desktop/desktop-footer/desktop-footer.component';
import { MenuPromoSwipeComponent } from './components/menu-promo-swipe/menu-promo-swipe.component';
import { SheetDirective } from './directives/sheet.directive';
import { DesktopAllergensComponent } from './desktop/desktop-allergens/desktop-allergens.component';

@NgModule({
  declarations: [
    AppComponent,
    MenuHomepageComponent,
    LandingpageComponent,
    FoodCardComponent,
    DrinkCardComponent,
    MenuCategoryPremiereComponent,
    MenuCategoryComponent,
    MenuCategoriesComponent,
    MenuBasketComponent,
    MenuBasketOrderComponent,
    MenuBasketDialogComponent,
    MenuFoodDialogComponent,
    MenuFoodRecomendationDialogComponent,
    MenuDrinkRecomendationDialogComponent,
    MenuDrinkDialogComponent,
    MenuNavigationComponent,
    RestaurantTitleComponent,
    FilterDialogComponent,
    IntToColorPipe,
    SortFoodsPipe,
    TimeFormatPipe,
    MenuHeaderImageComponent,
    MenuModificatorsGridComponent,
    MenuDialogFoodVariantsComponent,
    MenuRecomendationFoodVariantsComponent,
    MenuRecomendationDrinkVariantsComponent,
    MenuDialogDrinkVariantsComponent,
    MenuBasketFoodCardComponent,
    MenuBasketDrinkCardComponent,
    MenuRecomendationsComponent,
    MenuShowCardsComponent,
    MenuFooterComponent,
    LabelTranslatePipe,
    TranslatePipe,
    TitleTranslatePipe,
    PriceSeparatorPipe,
    CachedImagePipe,
    FieldTranslatePipe,
    FilterDrinksPipe,
    FilterFoodsPipe,
    MenuModificatorCardComponent,
    MenuRecomendationCardFoodComponent,
    MenuRecomendationCardDrinkComponent,
    LazyImageComponent,
    MenuEventCardComponent,
    MenuOrderComponent,
    MenuOrderDialogComponent,
    MenuOrderFoodCardComponent,
    MenuOrderDrinkCardComponent,
    MenuFooterDialogComponent,
    MenuSuccessPageComponent,
    MenuNotificationComponent,
    MenuCallingWaiterComponent,
    MenuWaiterCallComponent,
    MenuAllergenIconComponent,
    MenuAllergenPillComponent,
    MenuAllergenListComponent,
    MenuAllergyNoticeComponent,
    AllergenTranslatePipe,
    AllergensWithAddonsPipe,
    MenuSearchComponent,
    MenuLabelBannersComponent,
    DesktopMenuComponent,
    DesktopItemCardComponent,
    DesktopItemDialogComponent,
    DesktopEventsComponent,
    DesktopFooterComponent,
    MenuPromoSwipeComponent,
    SheetDirective,
    DesktopAllergensComponent,
  ],
  imports: [
    NgOptimizedImage,
    BrowserModule,
    AppRoutingModule,
    MatCardModule,
    MatToolbarModule,
    MatIconModule,
    MatDividerModule,
    MatDialogModule,
    MatSelectModule,
    MatFormFieldModule,
    MatOptionModule,
    MatInputModule,
    MatButtonModule,
    BrowserAnimationsModule,
    FormsModule,
    MatButtonToggleModule,
    HttpClientModule
  ],
  providers: [
    // Angular 21: по умолчанию без zone.js; меню рассчитано на zone.js —
    // обновление шаблонов после ответов Firebase
    provideZoneChangeDetection(),
    DataService,
    ...firebaseProviders,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
